// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Kgrz","productName":"Table_productName__MG8X8"};